module.exports = __webpack_public_path__ + "img/logo_konkatsu02.26790ddc.png";